import React, { MouseEventHandler, PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './Card.module.scss';
import { Icon } from '@gift/ui/components/icons/Icon';

export const Card = ({
    onClick, active,
    title, children, className
}: Props) => {

    const classes = classNames(styles.default, className, {
        'idt-active': active,
        'idt-inactive': !active
    });

    return (
        <>
            <div className={classes} onClick={onClick}>
                {children}
                {active && (
                    <div className={styles.checkmark}>
                        <Icon type='general-ui-checkmark' className={styles.icon} />
                    </div>
                )}
            </div>

            {title && (
                <p className={styles.name}>
                    {title}
                </p>
            )}
        </>
    );
};

type Props = PropsWithChildren<{
    onClick: MouseEventHandler,
    active?: boolean,
    className?: string,
    title?: string,
}>;
